import clsx from 'clsx';
import { FC } from 'react';
import { HeaderProps } from 'react-table';
import { PostTagDto } from '../../../feed-tags/tags-table/model/types'

type Props = {
	className?: string;
	title?: string;
	column: HeaderProps<PostTagDto>['column'];
};

const PostCustomHeader: FC<Props> = ({ className, title, column }) => {
	if (!column) return <th className={clsx(className)}>{title}</th>;

	return (
		<th {...column.getHeaderProps()} className={clsx(className)}>
			{title}
		</th>
	);
};

export { PostCustomHeader };
